import React from "react";
import SetupMaster from "./SetupMaster";

/* Roles Setup — restores legacy Admin/RolesSetup.aspx (SP_RE_Admin_RolesSetup_*).
   Grid and form behaviour live in SetupMaster.js; this file is the entity's config only.

   ROLE ID / GROUP ID are the pair that pc_users carries and the JWT already puts in the token
   (PC_USR_ROLE_ID, PC_GRP_ID). A role row simply names that pair so rights can hang off it —
   editing them here does not reassign any user. */

const config = {
    entity: "Role",
    title: "ROLE",
    addLabel: "Add Role",
    pk: "APP_ROLE_ID",
    endpoints: {
        list: "services/query/Setups/AppRole.php",
        save: "services/mutation/Setups/AppRole.php",
        del: "services/delete/setup/DeleteAppRole.php"
    },
    lookups: [],
    fields: [
        { name: "ROLE_CODE", label: "Role Code", type: "text", required: true, md: 3 },
        { name: "ROLE_NAME", label: "Role Name", type: "text", required: true, md: 4 },
        { name: "PC_USR_ROLE_ID", label: "User Role ID", type: "number", md: 2 },
        { name: "PC_GRP_ID", label: "Group ID", type: "number", md: 2 },
        { name: "ROLE_ACTIVE", label: "Active (1/0)", type: "number", md: 2 },
    ],
    columns: [
        { label: "CODE", field: "ROLE_CODE" },
        { label: "NAME", field: "ROLE_NAME" },
        { label: "ROLE ID", field: "PC_USR_ROLE_ID", align: "right" },
        { label: "GROUP ID", field: "PC_GRP_ID", align: "right" },
        { label: "ACTIVE", field: "ROLE_ACTIVE", align: "center" },
    ]
};

export default function RolesSetup(props) {
    return <SetupMaster config={config} {...props} />;
}
